// shared-text.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface PageHeader {
  header: string;
  subHeader: string;
}

@Injectable({ providedIn: 'root' })
export class SettingsService {
  private defaultText: PageHeader = {
    header: 'Einstellungen',
    subHeader: 'Hier kannst du jegliche Einstellungen für deinen Benutzeraccount durchführen.'
  };

  private _header$ = new BehaviorSubject<PageHeader>(this.defaultText);
  public header$ = this._header$.asObservable();

  setHeader(header: string, subHeader: string) {
    this._header$.next({ header, subHeader });
  }

  resetHeader() {
    this._header$.next(this.defaultText);
  }
}
